import React, { Fragment } from 'react';
import { Table, Modal } from 'antd';
import { connect } from 'dva';
import { formatPrice } from 'utils/utils.js';
import styles from './Table.less';

@connect(({ operationChargeItemPublishChargeItemSteps }) => ({
  dataSource: operationChargeItemPublishChargeItemSteps.step3NotificationTableDataSource,
}))
export default class AddressListTable extends React.Component {
  handleDelete = rowData => {
    Modal.confirm({
      title: '确认删除？',
      onOk: () => {
        const { dataSource, dispatch } = this.props;
        const newDataSource = [];

        dataSource.forEach(q => {
          if (q.userId !== rowData.userId) {
            newDataSource.push(q);
          }
        });

        dispatch({
          type: 'operationChargeItemPublishChargeItemSteps/saveUploadResponseTableDataSource',
          dataSource: newDataSource,
        });
      },
    });
  };

  render() {
    const columns = [
      {
        title: '学校',
        dataIndex: 'orgName',
      },
      {
        title: '年级',
        dataIndex: 'gradeName',
      },
      {
        title: '班级',
        dataIndex: 'className',
      },
      {
        title: '学生姓名',
        dataIndex: 'userName',
      },
      {
        title: '商品名称',
        dataIndex: 'commoditiesName',
        render: (val, record) => record.commodities.map(q => q.commodityName).join('、'),
      },
      {
        title: '已选规格',
        dataIndex: 'commoditiesSpec',
        render: (val, record) => record.commodities.map(q => q.propertyValues).join('、'),
      },
      {
        title: '应收总价格（元）',
        dataIndex: 'price',
        render: val => formatPrice(val),
      },
      {
        title: '操作',
        render: rowData => {
          return (
            <Fragment>
              <a onClick={this.handleDelete.bind(this, rowData)}>删除</a>
            </Fragment>
          );
        },
      },
    ];

    return (
      <div className={styles.root}>
        <Table
          rowKey="userId"
          dataSource={this.props.dataSource}
          columns={columns}
          pagination={false}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Operation/ChargeItem/PublishChargeItemSteps/Step3-Notification/UploadExcel/Table.js